import { useEffect, useState } from "react";

export const PressIcon: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [pressed, setPressed] = useState(false);
  useEffect(() => {
    if (!pressed) return;
    const up = () => setPressed(false);
    window.addEventListener("mouseup", up);
    return () => window.removeEventListener("mouseup", up);
  }, [pressed]);
  return (
    <span
      onMouseDown={() => setPressed(true)}
      style={{
        display: "inline-flex",
        transform: pressed ? "scale(0.78)" : "scale(1)",
        transition: pressed
          ? "transform 0.08s ease-in"
          : "transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)",
      }}
    >
      {children}
    </span>
  );
};
